import { computed } from 'mobx';

export default class EventTypeModel {
  id;
  store;

  constructor(store, item) {
    this.store = store;
    this.updateFromJson(item);
  }

  @computed get asJson() {
    return {
      id: +this.id,
      type: this.type,
      station_check: this.station_check,
      qc_check: this.qc_check,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.type = json.type;
    this.station_check = json.station_check;
    this.qc_check = json.qc_check;
  }
}



// WEBPACK FOOTER //
// ./src/models/Maintenance/Event/EventTypeModel.js